import { render, staticRenderFns } from "./DocumentCreate.vue?vue&type=template&id=9b0b9ae4&scoped=true&"
import script from "./DocumentCreate.vue?vue&type=script&lang=js&"
export * from "./DocumentCreate.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCreate.vue?vue&type=style&index=0&id=9b0b9ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0b9ae4",
  null
  
)

export default component.exports